<template lang="pug">
  .container-fluid.pb-5.p-3
    h2.text-center.mt-5.pb-5.text-white 外岩3Dモデル
    .row.mt-5
      .col-10.offset-1.col-lg-6.offset-lg-3
        h4.text-white トポがもっとわかりやすく
        .detail 3Dモデルの外岩にルートを表示することで、トポがさらに直感的にわかりやすくなりました。拡大表示すれば岩肌の細部までくっきり表現！ホールドの立体感も事前確認できるので、現地での登攀がもっと楽しみになりそうです…。
    .row.mt-5
      .col-10.offset-1.col-lg-6.offset-lg-3
        .model_img
          img(:src="getImgPath('3dModel1.png')", alt="")
     
    .row.mt-5
      .col-10.offset-1.col-lg-6.offset-lg-3
        h4.text-white こんな使い方も…
        .detail スマートフォンでAR機能ボタンをタップすると、お部屋の中や好きな場所に外岩をバーチャル表示することができます。リアルな外岩を見ながら登攀シミュレーションしてみましょう。
        .detail <small>（AR機能対象機種のみ。現在β版）</small>
    .row.mt-5
      .col-10.offset-1.col-lg-6.offset-lg-3
        .model_img
          img(:src="getImgPath('3dModel2.png')", alt="")

    .row.mt-5.pt-5.pb-5
      .col-10.offset-1.col-lg-6.offset-lg-3
        .detail
          |クライマーに人気の岩を中心に、ヤマラボ調査チームが各地を撮影しています。データ追加はこのページからご確認いただけます。
     
    //-3dモデルの岩リスト
    h3.text-center.mt-5.mb-5.text-white 公開中の外岩3Dモデル
    .col-12.col-lg-6.offset-lg-3
      .rockyCard.border.m-3.p-3(v-for="rock in this.rock3dList" @click="callRockyInfo(rock.rockyId,rock.rockId,rock.rockName)")
        .rocky {{ rock.rockyName }} <small>({{rock.address}})</small>
        .rock {{ rock.rockName }} <small>({{rock.grade}})</small>
        .model_thumb.mt-3
          img(:src="getThumbPath(rock.img)", alt="")

</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      blogData:null,
      rock3dList: [
        {'rockyId':14,'rockId':82,'rockyName':'御岳ボルダー','address':'東京都青梅市','rockName':'オーストラリア岩','grade':'10級～初段','img':'00082_b.png'},
        {'rockyId':14,'rockId':83,'rockyName':'御岳ボルダー','address':'東京都青梅市','rockName':'すべり台岩','grade':'10級～3級','img':'00083_b.png'},
        {'rockyId':14,'rockId':3045,'rockyName':'御岳ボルダー','address':'東京都青梅市','rockName':'岩名なし','grade':'7級～初段','img':'03045_b.png'},
        {'rockyId':256,'rockId':3380,'rockyName':'鳩ノ巣渓谷','address':'東京都西多摩郡奥多摩町','rockName':'嘴岩','grade':'5級～1級','img':'03380_b.png'},
        {'rockyId':210,'rockId':1648,'rockyName':'瑞牆ボルダー[山形県エリア]','address':'山梨県北杜市須玉町','rockName':'阿修羅','grade':'10級～四段','img':'01648_b.png'},
        {'rockyId':257,'rockId':3572,'rockyName':'小川山ボルダー[キャンプ場]','address':'長野県南佐久郡川上村','rockName':'キャンプ場 乙','grade':'10級～5級','img':'03572_b.png'},
        {'rockyId':258,'rockId':402,'rockyName':'小川山ボルダー[水晶スラブ周辺]','address':'長野県南佐久郡川上村','rockName':'入口岩','grade':'8級～初段','img':'00402_b.png'}
      ]
    }
  },
  created() {

  },
  methods: {
    //遷移リンク先
    callRockyInfo(rockyId,rockId,rockName) {
      //ルート画面を表示する
      this.$router.push({ 
        name: 'rockyInfo_:rockyId_:rockId', 
        params: { 
          rockyId:rockyId, 
          rockId:rockId,
          rockName:rockName,
          rockyMasterData:{},
        }
      })
    },
    getImgPath(img){
      return process.env.VUE_APP_MATERIAL_URL + "/img/3dModelLanding/" + img
    },
    getThumbPath(img){
      return process.env.VUE_APP_MATERIAL_URL + "/img/model/thumb/" + img
    },
  },
}
</script>

<style lang="stylus" scoped>

.container-fluid
  letter-spacing .05rem
  line-height 1.7
  background-color #000
  color #fff

.detail,h2,h3
  color #fff
  font-family '游明朝','Yu Mincho',YuMincho,'Hiragino Mincho Pro',serif;
.col-8.offset-2
  font-size 1.1rem

.rockyCard
 cursor pointer

.rocky
 color #007bff
 font-size 1.3rem

.rock
  font-size: 1.1rem

.model_img
  width 90%
  margin 0 auto
  img
    width 100%
    height auto

.model_thumb
  img
    width 100%
    height auto
  &:hover
    filter brightness(115%)

@media (min-width 768px)
  .model_img
    width 60%
</style>